import React, { useEffect, useState } from 'react'
import InputMask from 'react-input-mask';
import heroimage from "../../../../assets/search/search_expert.svg";
import ascending from "../../../../assets/productimage/ascending-bars.svg";
import descending from "../../../../assets/productimage/descending-bars.svg";
import locationpin from "../../../../assets/search/location-pin.svg";
import close_btn from '../../../../assets/images/white_cross.svg';
import mobile_banner from "../../../../assets/images/searchexperts_mobile.svg";
import name from "../../../../assets/search/user.svg";
import { Trans, useTranslation } from 'react-i18next';
import { Footer } from '../../../common/footer/footer';
 import newest from "../../../../assets/images/newest.svg";
 import expire_svg from "../../../../assets/images/expire_svg.svg";
import "../globalMainSearchExpert/globalMainSearchExpert.css";
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'aos/dist/aos.css';
import Filter from '../../../../shared/filter.jsx';
import { ExpertListCardJSX } from '../../../common/expertListCard/expertListCard';
import { Pagination } from '../../../common/pagination/uiPagination.js';


const GlobalMainSearchExpertJsx = (props) => {
  const {
    categoryData,
    onSubmitButtonClick,onSubmitButtonClick1,
    formData,
    onTouchHandler,
    onInputChange,
    formError,
   
    hitOldest,
    oldest,
    allOffersData,
    selectAll,
    selectAllHit,
    getAllFeauturedOffersData,
    selectCategory,
    selectSubCategory,
    subCategories,
    categories,
    onPaginationButtonClick,
    page,disableSelectAll

  } = props;
  const itemsPerPage = 10

  const [currentPage] = useState(1);
  const [filterrMenuOpen, setFilterrMenuOpen] = useState(false);
  const [sortMenuOpen, setSortMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [currentItems, setCurrentItems] = useState([]);
  const { t } = useTranslation();


  const checkMobileView = () => {
    setIsMobile(window.innerWidth <= 767);
  };

  useEffect(() => {
    checkMobileView(); // Initial check
    window.addEventListener('resize', checkMobileView); // Listen for window resize

    return () => {
      window.removeEventListener('resize', checkMobileView); // Clean up event listener
    };
  
  }, [])

  useEffect(() => {
    async function fetchData() {
      const currentItems = allOffersData?.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
      );
  
      setCurrentItems(currentItems);
    }
  
    fetchData();
  }, [page, itemsPerPage, allOffersData]);
  


  // {t("PRINT.TITLE")}
  return (
    <>
      <section className="expertsearchmain">
        <section className="institutesearchmainherosection">
          <img src={heroimage} alt='banner' className="d-none d-sm-block" />
          <img src={mobile_banner} alt='banner' className="d-block d-lg-none d-sm-none d-md-none "/>
          <div className="container">
            <div className="herotext">
              <div className="hero_subtext">
                <h2><Trans i18nKey="SEARCHEXPERT.TEXT1" ></Trans></h2>
              </div>
              <div className="hero_subtext2">
                <h2 ><Trans i18nKey="SEARCHEXPERT.TEXT3" ></Trans> <h3>{t("SEARCHEXPERT.TEXT4")}</h3></h2>
              </div>
             
              <div className="hero_subtext3">
                <h5><Trans i18nKey="SEARCHEXPERT.TEXT6" ></Trans></h5>
              </div>
            </div>
          </div> 
          <div className="container">
          <div className="forminsti d-flex">
            <div className="input-container ts">
              <InputMask mask={'a9a 9a9'} value={formData.postalCode} name="postalCode" onChange={onInputChange} onBlur={onTouchHandler}>
                {(inputProps) => <input {...inputProps}
                  type="text"
                  className={
                    formError['postalCode']
                      ? "input form-control  is-invalid"
                      : "input form-control"
                  }
                  placeholder={t("REGISTRATION.ENTERPOSTALCODE")}
                  id="forminstiinput"
                  disableUnderline />}
              </InputMask>
             
              <span><img src={locationpin} alt='' /></span>

            </div>
            <div className="input-container ts">
              <input
                type="text"
                className="form-control input"
                placeholder={t("REGISTRATION.ENTERNAME")}
                name="name"
                id="forminstiname"
                onChange={onInputChange}
                onBlur={onTouchHandler}
                value={formData.name}
              />
             
              <span><img src={name} alt='' /> </span>

            </div>
            
           
 
          </div> 
          <div className="showallourbesttwo d-flex justify-content-center text-center">
            <button type="submit"
              className={(!formData?.name?.length && !formData?.postalCode?.length) ? "contiue-button" : "showallourbesttoo"}
              disabled={!formData?.name?.length && !formData?.postalCode?.length}
              onClick={() => onSubmitButtonClick1()}>Reset</button>
           
            <button type="submit"
              className={(!formData?.name?.length && !formData?.postalCode?.length) ? "contiue-button" : "showallourbesttoo"}
              disabled={!formData?.name?.length && !formData?.postalCode?.length}
              onClick={() => onSubmitButtonClick()}>{t("COMMON.SEARCH")}</button>
            </div>
        </div>
          </section>
        
        <div className="container" id="searchexpert">
          <div className="instisearchheading">
            <h2>{t("SEARCHEXPERT.SEARCHEXPERTTITLE")}</h2>
            <h3>{t("SEARCHEXPERT.SEARCHEXPERTSUBTITLE")}</h3>
          </div>
          {isMobile ? <div className="mobile-filter sortingdiv">
          <div className="container">
            <div className="d-flex mobiledrop">
              <div className="dropdown dropfilter">
                <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownFilter" onClick={() => {setSortMenuOpen(!sortMenuOpen);setFilterrMenuOpen(false)}} >
                {t("COMMON.SORTBY")}
                </button>
                {sortMenuOpen &&
                  <div className="dropdown-menu-open" aria-labelledby="dropdownFilter">
                   <button className="close_btn"  onClick={() => { setSortMenuOpen(!sortMenuOpen); setFilterrMenuOpen(false) }}><img src={close_btn} alt={t("CUSTOMERINTEREST.CLOSEBUTTON")} /></button>
                    <ul>
                      <li className={!oldest ? "active" : ""}><button onClick={() => hitOldest(false)}>
                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" checked={!oldest} value="" id="Checkme1" /><span className="subcatimage"><img src={newest} alt="newest" /></span>  {t("COMMON.ASC")}</div></button></li>
                      <li className={oldest ? "active" : ""}><button onClick={() => hitOldest(true)}>
                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" checked={oldest} value="" id="Checkme1" /><span className="subcatimage"><img src={expire_svg} alt ="newest" /></span>  {t("COMMON.DESC")}</div></button></li>
                      {/* <a className="dropdown-item" href="#">Action</a> */}
                    </ul>
                  </div>
                }
              </div>
              <div className="dropshortby">
                <button className="btn btn-secondary dropdown-toggle"  onClick={() => {setFilterrMenuOpen(!filterrMenuOpen);setSortMenuOpen(false)}} type="button" id="dropdownShortBy">
                {t("COMMON.FILTER")}
                </button>
                <div class={`${filterrMenuOpen===true ? 'open-active' : ''} filter-wrap`} aria-labelledby="dropdownShortBy">
                <button className="close_btn btm-btn"  onClick={() => { setFilterrMenuOpen(!filterrMenuOpen); setSortMenuOpen(false) }} ><img src={close_btn} alt={t("CUSTOMERINTEREST.CLOSEBUTTON")} /></button>
                  <Filter
                    categoryData={categoryData}
                    selectAll={selectAll}
                    selectAllHit={selectAllHit}
                    selectCategory={selectCategory}
                    selectSubCategory={selectSubCategory}
                    subCategories={subCategories}
                    categories={categories}
                    disableSelectAll={disableSelectAll}

                  />
                </div>
              </div>
            </div>
          </div>
        </div> : <>
          <Filter
            categoryData={categoryData}
            selectAll={selectAll}
            selectAllHit={selectAllHit}
            getAllFeauturedOffersData={getAllFeauturedOffersData}
            selectCategory={selectCategory}
            selectSubCategory={selectSubCategory}
            subCategories={subCategories}
            categories={categories}
            disableSelectAll={disableSelectAll}

          />
          <section className="sortingdiv">
            <div className="container">
              <span className="shortby">{t("COMMON.SORTBY")}</span>
              <ul>
                <li className={!oldest ? "active" : ""}><button onClick={() => hitOldest(false)}><img alt="icon" src={ascending} className="descending" /> {t("COMMON.ASC")}</button></li>
                <li className={oldest ? "active" : ""}><button onClick={() => hitOldest(true)}><img alt="icon" src={descending} className="descending" /> {t("COMMON.DESC")}</button></li>
              </ul>
            </div>
          </section>
          </>}
          <section className="institutesearchmainlistingsection">
            <div className="container">
              {
                currentItems?.map((offer,index) => {
                  return (
                    <ExpertListCardJSX
                      offerimageUrl={offer?.imageUrl}
                      offerbusinessPhoneNumber={offer.expertSpecializations[0].businessPhoneNumber}
                      offercity={offer.expertSpecializations[0].city}
                      offeremail={offer.email}
                      offerfirstName={offer?.firstName}
                      offerslugUrl={offer?.slugUrl}
                      offerlastName={offer?.lastName}
                      expertSpecializations={offer.expertSpecializations}
                      offerplanName={offer.planName}
                      status={offer.status}
                      offercategoryName={offer.expertSpecializations[0]?.categoryName}
                      offername={offer?.name}
                    // categoryName={cat.categoryName}
                    offer={offer}
                      key={index}
                    />
                    
                  )
                })
              }


            </div>
            {(!currentItems || currentItems.length < 1) &&
            <h4 className="text-center mt-3">{t('COMMON.NOSEARCHRESULT')}</h4>
            }
            {(currentItems && currentItems.length > 0) &&
            <section className="newpagination"> <Pagination
              currentPage={currentPage}
              page={page}
              allOffersData={allOffersData}
              currentItems={currentItems}
              itemsPerPage={itemsPerPage}
              onPaginationButtonClick={onPaginationButtonClick}
            /></section>
            }
            
          </section>
          <Footer />
        </div>
      </section>
    </>

  );
};

export default GlobalMainSearchExpertJsx;